<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <septic-field-form-group
        :submission="submission_data"
        :index="index"
        @onFieldChange="onFieldChange"
      ></septic-field-form-group>
      <div v-if="submission_data.samples && submission_data.samples.length">
        <septic-sample-form-group
          v-for="(sample, sampleIndex) in submission_data.samples"
          :key="sample.test_package_sample_id"
          :sample="sample"
          :addOns="addOns"
          :index="sampleIndex"
          :submission="submission"
          @onSampleChange="onSampleChange"
          @removeSample="removeSample"
        ></septic-sample-form-group>
      </div>
      <hr />
      <b-row class="mt-3" align-h="end">
        <b-col cols="2">
          <b-button variant="success" block @click="addSample()">
            <i class="fa fa-plus" /> Add Sample
          </b-button>
        </b-col>
      </b-row>
      <div v-if="turnArounds && turnArounds.models.length">
        <hr />
        <turn-around-select
          :turnArounds="turnArounds"
          :selectedTurnAround="submission_data.turnaround"
          @onTurnAroundSelect="onTurnAroundSelect"
        ></turn-around-select>
      </div>
      <div v-if="serviceQuestions && serviceQuestions.models.length">
        <hr />
        <service-question
          v-for="(serviceQuestion, index) in serviceQuestions.models"
          :serviceQuestion="serviceQuestion"
          :key="index"
        ></service-question>
      </div>
      <b-button variant="danger" block @click="removeSubmission"
        ><i class="fal fa-trash"></i
      ></b-button>
    </b-card>
  </div>
</template>

<script>
import SepticFieldFormGroup from "./SepticFieldFormGroup";
import SepticSampleFormGroup from "./SepticSampleFormGroup";
import ServiceQuestionCollection from "../../../../collections/lab/ServiceQuestionCollection";
import TestPackageSampleCollection from "../../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import TurnaroundCollection from "../../../../collections/lab/TurnaroundCollection";
import TurnAroundSelect from "../../TurnAroundSelect";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "SepticForm",
  components: {
    SepticFieldFormGroup,
    SepticSampleFormGroup,
    TurnAroundSelect
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    index: {
      type: Number,
      default: null
    },
    serviceQuestions: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    }
  },
  data() {
    return {
      submission_data: null
    };
  },
  validations: {
    submission_data: {
      identifier: { required }
    }
  },
  methods: {
    onFieldChange(data) {
      if (data) {
        this.submission_data.identifier = data.identifier;
        this.submission_data.event_code = data.event_code;
        this.emitSubmissionChange();
      }
    },
    onSampleChange(params) {
      if (params) {
        let sample = params.sample;
        let index = params.index;
        if (
          this.submission_data.samples &&
          this.submission_data.samples.length &&
          sample &&
          index !== null
        ) {
          this.submission_data.samples.splice(index, 1, sample);
          this.emitSubmissionChange();
        }
      }
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.submission_data.turnaround_id = turnaround.id;
        this.emitSubmissionChange();
      } else {
        this.submission_data.turnaround = null;
        this.submission_data.turnaround_id = null;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    },
    addSample () {
      const lastSample = this.submission_data.samples[this.submission_data.samples.length - 1]

      const newSample = {
        ...lastSample,
        test_package_sample_id: this.$uuid.v4(),
        identifier: `Sample ${this.submission_data.samples.length + 1}`
      }

      this.submission_data.samples.push(newSample)
      this.emitSubmissionChange()
    },
    removeSample (id) {
      this.submission_data.samples = this.submission_data.samples.filter((e) => e.test_package_sample_id !== id)
      
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      })
    }
  },
  watch: {
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
